// extracted by mini-css-extract-plugin
module.exports = {"section":"_gJDGhoy","header":"_3m8i5wv","gameImage":"_tbk2ATc","title":"_m0PBG-E","titleTextSize":"_H7lIhit","container":"_KN3prtt","buttons":"_1rZ6DBY","image":"_1wlprLT"};